import React, { useState } from "react";
import ImageIcon from "@mui/icons-material/Image";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import Uploadmuitiplefile from "../../common/Uploadmultplefile";
import { Plus, Upload, X } from "lucide-react";
import toast from "react-hot-toast";
import Commonmodal from "../../common/Commonmodal";

const Vehicleimages = ({
  vehicleImages,
  getVehicleProfileImagesAPI,
  selectedRow,
  systemUserList,
  handleImageOpen,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const vehicleImageType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleImageType;
  delete vehicleImageType?.inverted;
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    name: "",
    imagetype: "",
    file: [],
    attachments: [],
  });
  const [uploadedImages, setUploadedImages] = useState([]);
  

  const handleChange = async (field, value) => {
    if (field !== "file") {
      setForm((prev) => ({ ...prev, [field]: value }));
    } else {
      if (!value) return;
      const res = await Uploadmuitiplefile(value, "vehicles", "vehicle");
      const urls = res?.uploaded?.map((u) => u?.Location || u?.url);
      setUploadedImages(urls);
      setForm((prev) => ({
        ...prev,
        file: urls,
        attachments: res?.uploaded,
      }));
    }
  };

  const handleSaveDocument = async () => {
    if (!form.name || !form.imagetype || !form.file) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/api/vehicleimages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          name: form?.name,
          imageType: form?.imagetype,
          vehicleId: selectedRow?.id,
          imageUrl: form?.file[0],
          attachments: JSON.stringify(form?.attachments),
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Image uploaded successfully");
        setForm({});
        setUploadedImages(null);
        setOpen(false);
        getVehicleProfileImagesAPI?.(selectedRow?.id);
      } else {
        toast.error(data?.msg || "Upload failed");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      {open && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-lg rounded-xl shadow-xl p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Upload Image</h3>
              <button
                onClick={() => {
                  setOpen(false);
                  setForm({});
                }}
              >
                <X className="text-slate-500 hover:text-red-500" />
              </button>
            </div>

            {/* Form */}
            <div className="space-y-4">
              <input
                name="name"
                placeholder="Image Name"
                className="w-full border rounded-lg px-4 py-2 text-sm"
                value={form.name}
                onChange={(e) => handleChange("name", e.target.value)}
              />
              <select
                className="w-full rounded-md bg-gray-50 border border-gray-200 px-3 py-2 text-sm text-gray-800 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                value={form.documenttype}
                onChange={(e) => handleChange("imagetype", e.target.value)}
              >
                <option value="">Select Image Type</option>
                {Object.entries(vehicleImageType).map(([key, label]) => (
                  <option key={key} value={key}>
                    {label}
                  </option>
                ))}
              </select>

              {/* File Upload */}
              <label className="border-2 border-dashed rounded-lg p-4 text-center cursor-pointer hover:bg-slate-50 transition">
                {uploadedImages ? (
                  <div className="grid grid-cols-3 gap-2">
                    {uploadedImages?.map((src, i) => (
                      <img
                        key={i}
                        src={src}
                        alt="Preview"
                        className="h-24 w-full object-cover rounded"
                      />
                    ))}
                  </div>
                ) : (
                  <Upload className="mx-auto text-slate-400 mb-1" />
                )}
                <p className="text-sm text-slate-600">
                  {form.file ? "File selected" : "Click to upload document"}
                </p>
                <input
                  type="file"
                  name="file"
                  className="hidden"
                  multiple
                  onChange={(e) => handleChange("file", e.target.files)}
                />
              </label>
            </div>

            {/* Actions */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => {
                  setOpen(false);
                  setForm({});
                }}
                className="px-4 py-2 border rounded-lg text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveDocument}
                className="px-5 py-2 bg-teal-600 text-white rounded-lg text-sm hover:bg-teal-700"
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="overflow-x-auto rounded-lg border p-4">
        <table className="w-full">
          <thead className="bg-slate-50 border-b">
            <tr>
              {[
                "Image Name",
                "Image Type",
                "Image",
                "Attachments",
                "Uploaded On",
                "Created By",
              ].map((h, i) => (
                <th
                  key={i}
                  className="text-left py-3 px-4 text-xs font-semibold uppercase text-slate-500"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {vehicleImages.length === 0 ? (
              <tr>
                <td
                  colSpan={6}
                  className="text-center py-6 text-sm text-slate-500"
                >
                  No Images uploaded
                </td>
              </tr>
            ) : (
              vehicleImages.map((item, idx) => (
                <tr key={idx} className="border-b hover:bg-teal-50 transition">
                  <td className="py-4 px-4">{item?.name}</td>
                  <td className="py-4 px-4">
                    {vehicleImageType[item?.imageType]}
                  </td>
                  <td className="py-4 px-4 flex items-center gap-3">
                    <button
                      onClick={() => handleImageOpen(item?.imageUrl)}
                      className="text-blue-600 hover:text-blue-800"
                      title="Preview"
                    >
                      <ImageIcon fontSize="medium" />
                    </button>
                    <span className="text-sm text-gray-800 truncate max-w-[200px]">
                      {item?.fileName}
                    </span>
                  </td>
                  <td className="py-4 px-4">
                    {(() => {
                      let attachments = [];

                      try {
                        attachments = JSON.parse(item?.attachments || "[]");
                      } catch (e) {
                        attachments = [];
                      }

                      return attachments.length > 0 ? (
                        <div className="flex gap-2 flex-wrap">
                          {attachments.map((att, index) => (
                            <button
                              key={index}
                              onClick={() => handleImageOpen(att.url)}
                              className="flex items-center gap-2 group"
                            >
                              <img
                                src={att.url}
                                alt={`${item.name}-${index}`}
                                className="h-8 w-10 object-cover rounded border"
                              />
                            </button>
                          ))}
                        </div>
                      ) : (
                        "-"
                      );
                    })()}
                  </td>

                  <td className="py-4 px-4">{item?.createdAt}</td>
                  <td className="py-4 px-4">
                    {systemUserList?.filter(
                      (list) => list?.id === item?.createdBy,
                    )[0]?.name || "-"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="flex justify-end p-4">
        <button
          onClick={() => setOpen(true)}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 transition"
        >
          <Plus size={16} /> Upload Image
        </button>
      </div>
    </>
  );
};

export default Vehicleimages;
